module.exports = __webpack_public_path__ + "static/img/fahrzeugsuche.e0fb399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_page/teaser/fahrzeugsuche.jpg
// module id = x6VE
// module chunks = 1